<form #proximityForm="ngForm">
  <div class="modal-header">
    <h5>Proximity Criteria</h5>
  </div>
  <div class="modal-body text-center">
    <div class="input-div">
      <label class="form-label mr-2">Building</label>      
      <div class="d-flex flex-row">
        <i *ngIf="bBuildingsLoading" class="fa fa-spinner fa-spin mr-2"></i>
      <select class="form-control w-100" name="building"
      [(ngModel)]="selectedBuilding" (ngModelChange)="onBuildingIdChange($event)">

        <option [ngValue]="null">-- None (enter coordinates) --</option>
        <option *ngFor="let building of buildings" [ngValue]="building">
                                {{building.id}} - {{building.commonName}}</option>
      </select>
      </div>
    </div>
    <div class="input-div">
      <label class="form-label">Latitude</label>
      <input name="lat" size=15 type="number" class="form-control" #lat="ngModel" required 
      [(ngModel)]="formData.lat" [min]="-90" [max]="90" [readOnly]="!!selectedBuilding"/>
      <div class="text-danger small" *ngIf="lat.dirty&&lat.invalid">Invalid (-90 to 90)</div>
    </div>
    <div class="input-div">
      <label class="form-label">Longitude</label>
      <input name="lng" size=15 type="number" class="form-control" #lng="ngModel" required [(ngModel)]="formData.lng" [min]="-180"
        [max]="180"  [readOnly]="!!selectedBuilding"/>
      <div class="text-danger small" *ngIf="lng.dirty&&lng.invalid">Invalid (-180 to 180)</div>
    </div>
    <div class="input-div">
      <label class="form-label">Search Radius (meters)</label>
      <input name="radius" size=15 type="number" class="form-control" #radius="ngModel" required [(ngModel)]="formData.meters"
        [min]="0" />
      <div class="text-danger small" *ngIf="radius.dirty&&radius.invalid">Positive number required</div>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button class="btn btn-primary" (click)="ok()"
      [disabled]="proximityForm.pristine||proximityForm.disabled">Ok</button>
    <button class="btn btn-secondary" (click)="clear()" title="Clear filter and close editor">Clear</button>
    <button class="btn btn-warning" (click)="cancel()">Cancel</button>
  </div>
</form>